export const SET_USERINFO = (state, data) => {
  state.userInfo = data
  localStorage.setItem('userInfo', JSON.stringify(data))
}

export const CLEAR_USERINFO = (state) => {
  state.userInfo = {}
  localStorage.setItem('userInfo', '')
}



// WEBPACK FOOTER //
// ./src/store/mutations.js